/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Коллекция для избранного
   */
  var Wish = app.Collection.extend({

    model: app.WishItem,

    run: function () {
      /**
       * Пробрасываем в GTM события добавления и удаления из избранного
       */
      this.on(
        'add',
        function (model) {
          app.recommendationsEvents.trigger('itemInFavorite', model);
        }
      );
      this.on(
        'remove',
        function (model) {
          app.recommendationsEvents.trigger('itemOutFavorite', model);
        }
      );

    },
    /**
     * Добавляет товары в избранное по списку их id.
     * @param {array} ids Массив с id товаров, которые должны быть добавлены в избранное.
     */
    addByItemIds: function (ids) {
      if (ids && ids.length && !this.isStarted) {
        var that = this;
        this.isStarted = true;
        this.sync('create', this, {
          data: {
            items: ids
          },
          url: app.entryScriptName + '/api/v3/wish/',
          wait: true,
          method: 'POST',
          success: function (data) {
            that.isStarted = false;
            if (data.wish_items && data.wish_items.length) {
              that.add(data.wish_items);
            }
          },
          processData: true
        });
      }
    },

    /**
     * Удаляет товары из избранного по списку их id.
     * @param {Array} ids Массив с id товаров
     */
    deleteByItemsIds: function (ids) {
      if (ids && ids.length) {
        var that = this;
        this.sync('delete', this, {
          url: app.entryScriptName + '/api/v3/wish-item/' + ids + '/',
          wait: true,
          method: 'DELETE',
          success: function () {
            that.remove(ids);
            if (app.wishItems) {
              app.wishItems.trigger('removeCheckedFromWish', ids.length, ids);
            }
          }
        });
      }
    }
  });

  app.wish = new Wish();

})();

}.call(window));